// extracted by mini-css-extract-plugin
export var sliderRange = "_ok-2";
export var sliderRoot = "_ok-0";
export var sliderThumb = "_ok-3";
export var sliderTrack = "_ok-1";